module.exports = __webpack_public_path__ + "fonts/Axiforma-Light.fe89ffb.ttf";